<div class="development-placeholder">
  <img ngSrc="assets/img/placeholder.svg" height="499" width="680" alt="Функционал в разработке" />
  <h1 class="in-development">Функционал в разработке</h1>
</div>
